import { ExternalLink, Trophy, ShieldCheck } from "lucide-react";

const FFF_CLUB_URL = "https://epreuves.fff.fr/competition/club/582103-villeurbanne-united-f-c";

const CATEGORIES = [
  { label: "Seniors", teams: ["SENIORS 1"], color: "bg-emerald-600" },
  { label: "Loisirs", teams: ["LOISIRS 1"], color: "bg-emerald-600" },
  { label: "U19", teams: ["U19 1"], color: "bg-[#DC2626]" },
  { label: "U17", teams: ["U17 1", "U17 2", "U17 3"], color: "bg-[#DC2626]" },
  { label: "U15", teams: ["U15 1", "U15 2", "U15 3"], color: "bg-[#DC2626]" },
  { label: "U13", teams: ["U13 1", "U13 2", "U13 3", "U13 4"], color: "bg-[#1E3A8A]" },
];

export default function Classements() {
  return (
    <div data-testid="classements-page">
      {/* Hero */}
      <section className="bg-[#0F172A] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
          <div className="text-xs tracking-[0.3em] uppercase text-[#D97706] font-semibold mb-3">Saison 2025 – 2026</div>
          <h1 className="font-bold leading-tight text-4xl sm:text-5xl lg:text-6xl" style={{ fontFamily: "Outfit" }}>
            Classements <span className="text-[#D97706]">officiels</span>.
          </h1>
          <p className="mt-5 text-slate-300 max-w-2xl leading-relaxed">
            Les classements de toutes nos équipes sont mis à jour en direct sur le site officiel de la Fédération Française de Football.
            Consultez-les en un clic ci-dessous — données officielles, à jour après chaque journée.
          </p>

          <a
            href={FFF_CLUB_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="fff-main-link"
            className="mt-8 inline-flex items-center gap-2 px-6 py-3.5 bg-[#D97706] hover:bg-[#B45309] text-white font-semibold rounded-md transition-colors"
          >
            <Trophy size={18} />
            Voir tous nos classements sur FFF.fr
            <ExternalLink size={16} />
          </a>
        </div>
      </section>

      {/* Why FFF */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex items-start gap-4 p-5 bg-blue-50 border-l-4 border-[#1E3A8A] rounded-md" data-testid="info-callout">
          <ShieldCheck size={22} className="text-[#1E3A8A] shrink-0 mt-0.5" />
          <div>
            <div className="font-semibold text-[#0F172A]" style={{ fontFamily: "Outfit" }}>Source officielle</div>
            <p className="text-sm text-[#475569] mt-1 leading-relaxed">
              Nous redirigeons directement vers la FFF pour vous garantir des <strong>données toujours fiables et à jour</strong> :
              points, buts marqués/encaissés, journée en cours, et évolution après chaque match officiel.
            </p>
          </div>
        </div>
      </section>

      {/* Teams list */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <div className="text-xs tracking-[0.3em] uppercase text-[#D97706] font-semibold mb-3">Nos 13 équipes</div>
        <h2 className="font-bold text-2xl lg:text-3xl text-[#0F172A] mb-6" style={{ fontFamily: "Outfit" }}>
          Toutes les équipes du club
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="teams-grid">
          {CATEGORIES.map((cat) => (
            <div
              key={cat.label}
              className="border border-[#E2E8F0] rounded-lg overflow-hidden bg-white hover:shadow-md transition-shadow"
              data-testid={`cat-${cat.label}`}
            >
              <div className={`${cat.color} px-4 py-2.5 text-white font-semibold`} style={{ fontFamily: "Outfit" }}>
                {cat.label}
              </div>
              <div className="p-4">
                <ul className="space-y-1.5 text-sm text-[#475569]">
                  {cat.teams.map((t) => (
                    <li key={t} className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#D97706]" />
                      {t}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4 p-5 rounded-lg bg-slate-50 border border-[#E2E8F0]">
          <div className="flex-1">
            <div className="font-semibold text-[#0F172A]" style={{ fontFamily: "Outfit" }}>Besoin du classement d'une équipe en particulier ?</div>
            <p className="text-sm text-[#475569] mt-1">
              Depuis la page FFF du club, cliquez sur une équipe pour afficher son classement complet et son calendrier.
            </p>
          </div>
          <a
            href={FFF_CLUB_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="fff-secondary-link"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#1E3A8A] hover:bg-[#1E40AF] text-white font-semibold rounded-md transition-colors text-sm"
          >
            Ouvrir sur FFF.fr
            <ExternalLink size={14} />
          </a>
        </div>
      </section>
    </div>
  );
}
